import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDealBoardColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5C9 10.1193 10.1193 9 11.5 9C12.8807 9 14 10.1193 14 11.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 20,
			r: 2.5,
			fill: "#AC8EFF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 28.5,
			r: 2.5,
			fill: "#51B7D8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 2.5,
			fill: "#AC8EFF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 11.5,
			r: 2.5,
			fill: "#656CFF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 28.5,
			cy: 20,
			r: 2.5,
			fill: "#AC8EFF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 28.5,
			r: 2.5,
			fill: "#51B7D8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 28.5,
			cy: 11.5,
			r: 2.5,
			fill: "#656CFF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 28.5,
			cy: 28.5,
			r: 2.5,
			fill: "#51B7D8"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 9,
			width: 5,
			height: 5,
			fill: "white"
		})
	]
});
export default SvgDealBoardColored;
